import './App.css';
import FilterHeader from './components/layout';

function App() {
  return (
    <div className="App">
      <FilterHeader />
    </div>
  );
}

export default App;
